import { Grid, Typography, Divider } from '@material-ui/core';
import { FuncaoParticipante } from 'common/genericTypes';
import { MdSpace, LgSpace, Dropdown, Option, Button } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store';

const Instrumento: React.FC = () => {
  const isUsuarioAdministradorFiduciario = useSelector((state: RootState) => Boolean(state.auth.usuario.participante.funcao === FuncaoParticipante.AdministradorFiduciario));
  
  const todosInstrumentos: Option[] = [
    { description: 'CDCA', value: 'CDCA' },
    { description: 'Cotas de Fundo', value: 'COTAS_FUNDO' },
    { description: 'CR', value: 'CERTIFICADO_RECEBIVEIS' },
    { description: 'CRA', value: 'CRA' },
    { description: 'CRI', value: 'CRI' },
    { description: 'Debênture', value: 'DEBENTURE' },
    { description: 'Nota Comercial', value: 'NOTA_COMERCIAL' },
  ];

  const instrumentosAdministradorFiduciario: Option[] = [
    { description: 'Cotas de Fundo', value: 'COTAS_FUNDO' },
  ];

  const instrumentos = isUsuarioAdministradorFiduciario ? instrumentosAdministradorFiduciario : todosInstrumentos;

  const history = useHistory();

  const [instrumento, setInstrumento] = useState<string>('');

  useEffect(() => {
    if (isUsuarioAdministradorFiduciario) {
      setInstrumento('COTAS_FUNDO');
    }
  }, [isUsuarioAdministradorFiduciario]);

  const handleClick = () => {
    switch (instrumento) {
      case 'DEBENTURE':
        history.push('/instrumentos/gerenciar/cadastro/debenture/interop');
        return;
      case 'CRA':
        history.push('/instrumentos/gerenciar/cadastro/cra/interop');
        return;
      case 'CDCA':
        history.push('/instrumentos/gerenciar/cadastro/cdca/interop');
        return;
      case 'COTAS_FUNDO':
        history.push('/instrumentos/gerenciar/cadastro/cotas-de-fundo/interop');
        return;
      case 'CRI':
        history.push('/instrumentos/gerenciar/cadastro/cri/interop');
        return;
      case 'NOTA_COMERCIAL':
        history.push('/instrumentos/gerenciar/cadastro/nota-comercial/interop');
        return;
      case 'CERTIFICADO_RECEBIVEIS':
        history.push('/instrumentos/gerenciar/cadastro/certificado-recebiveis/interop');
        return;
      default:
        break;
    }
  };

  return (
    <div>
      <Typography variant="h1">{'Cadastro de Instrumento'}</Typography>
      <MdSpace />
      <>
        <Divider variant="fullWidth" />
        <MdSpace />
        <Grid container justify="center">
          <Grid item sm={4}>
            <Typography variant="h3" align="center">
              {'Antes de começar, nos informe o Instrumento a ser cadastrado:'}
            </Typography>
            <MdSpace />
            <Dropdown
              label={'Instrumento'}
              onChange={(value) => setInstrumento(value)}
              options={instrumentos}
              required
              value={instrumento}
            />
            <MdSpace />
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            disabled={!instrumento}
            style={{ marginRight: 20 }}
          >
            {'Próximo Passo'}
          </Button>
        </Grid>
        <LgSpace />
      </>
    </div>
  );
};

export default Instrumento;
